import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { HttpWrapperService } from '../http-wrapper/http-wrapper.service';

@Injectable()
export class ClientService {

  constructor(private http: HttpWrapperService) { }
  
  public getClients() {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_CLIENTS_API;
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }



  public createClient(clientData) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CREATE_CLIENT_API;
    return this.http.post(url, clientData, { headers: headers }).toPromise().then(res => res.json());
  }

  public updateClient(clientData, id) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.UPDATE_CLIENT_API + `/${id}`;
    return this.http.put(url, clientData, { headers: headers }).toPromise().then(res => res.json());
  }


  public deleteClient(clientData) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DELETE_CLIENT_API + `/${clientData.id}`;
    return this.http.delete(url, { headers: headers }).toPromise().then(res => res.json());
  }
  public restoreClient(clientData) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.RESTORE_CLIENT_API + `/${clientData.id}`;
    return this.http.post(url,{client_id: clientData.id}, { headers: headers }).toPromise().then(res => res.json());
  }


  public changeClientStatus(clientData) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CHANGE_CLIENT_STATUS_API;
    return this.http.post(url, clientData, { headers: headers }).toPromise().then(res => res.json());
  }


  public getAdminstratorData() {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_ADMINISTRATORS_API;
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/client-service/client.service.ts